/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_As_Of_No_Audit_DataInputs */

const en_cargos_as_of_no_audit_data = /** @type {(inputs: Cargos_As_Of_No_Audit_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audit history for this cargo; showing current quantities.`)
};

const es_cargos_as_of_no_audit_data = /** @type {(inputs: Cargos_As_Of_No_Audit_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin historial de auditoría para esta carga; mostrando cantidades actuales.`)
};

/**
* | output |
* | --- |
* | "No audit history for this cargo; showing current quantities." |
*
* @param {Cargos_As_Of_No_Audit_DataInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_no_audit_data = /** @type {((inputs?: Cargos_As_Of_No_Audit_DataInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_No_Audit_DataInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_no_audit_data(inputs)
	return es_cargos_as_of_no_audit_data(inputs)
});